var map = {
	"./en-US/common.json": 36326,
	"./en-US/error.json": 7289,
	"./en-US/page.json": 77318,
	"./en-US/panel.json": 4677,
	"./en-US/seo.json": 10497,
	"./zh-TW/common.json": 47715,
	"./zh-TW/error.json": 41244,
	"./zh-TW/page.json": 84451,
	"./zh-TW/panel.json": 97196,
	"./zh-TW/seo.json": 66499
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56848;